import { IconPosthogLogo } from '../icons'

export function PostHogLogo() {
    return (
        <a href="https://posthog.com/surveys" target="_blank" rel="noopener" className="footer-branding">
            Survey by {IconPosthogLogo}
        </a>
    )
}
